import { call, put, select } from 'redux-saga/effects';
import cirrusClient from '../../../services/api/cirrus-client';
import { setCallHistory } from '../../../state/callHistory/callHistorySlice';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice'

export function* fetchCallHistorySaga() {
  try {
    // Fetch user credentials from Redux store
    const { uid } = yield select(selectUserCredentials);

    // Current date and time
    const startDate = new Date();
    // 180 days from now
    const endDate = new Date();
    endDate.setDate(startDate.getDate() - 180);

    // API endpoint for retrieving call history (relative URL)
    const apiUrl = '?object=cdr2&action=read';
    // Parameters for the API call
    const params = {
      limit: '200', // Limit the number of records, adjust as needed
      uid: uid,
      showhidden: '0' // Assuming we don't want to show hidden records
    };

    // Make the API call with the credentials
    const response = yield call(cirrusClient.get, apiUrl, { params });
    yield put(setCallHistory(response.data));

  } catch (error) {
    console.error('Error fetching call history:', error);
  }
}
